// extracted by mini-css-extract-plugin
module.exports = {"phoneFieldParent":"sign-up_phoneFieldParent__2QSfP","disclaimer":"sign-up_disclaimer__3wlsi","resendHeader":"sign-up_resendHeader__3r7uP"};